module.exports = __webpack_public_path__ + "static/media/rugby.3013e5b6.svg";